export enum ENVIRONMENT {
    DEVELOPMENT = 'development',
    PRODUCTION = 'production',
}

export const isBrowser = () => typeof window !== 'undefined';

// Auto-detect current environment (with fallback to DEVELOPMENT)
export function getCurrentEnv(): ENVIRONMENT {
    const lifecycle = isBrowser()
        ? (window as any).__SERVER_DATA__?.request?.lifecycle
        : undefined;

    if (
        lifecycle &&
        Object.values(ENVIRONMENT).includes(lifecycle as ENVIRONMENT)
    ) {
        return lifecycle as ENVIRONMENT;
    }
    return ENVIRONMENT.DEVELOPMENT;
}

export const getUserId = (): string => {
    const serverData = (window as any).__SERVER_DATA__;
    if (!isBrowser() || !serverData) {
        throw new Error('[Braze] getUserId: __SERVER_DATA__ is not available.');
    }

    const userId = serverData.user?.publicId;
    const organizerId =
        serverData.activeOrganizationId ||
        serverData.user?.activeOrganization?.id; //for reporting tab from side panel

    if (!organizerId || !userId) {
        console.error(
            '[Braze] getUserId: Missing or invalid organizerId or userId in __SERVER_DATA__.',
            { organizerId: organizerId, userId: userId },
        );
        throw new Error(
            '[Braze] getUserId: Valid organizerId and userId are required.',
        );
    }
    return `${organizerId}-${userId}`;
};
